import { useRef, useState } from "react";
import styles from "./index.module.scss";
import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import SubscriptionsTable from "../../distributor-settings/subscriptions/subscriptions-table";
import { plansData } from "../../distributor-settings/subscriptions/subscriptions-table/mock.data";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { ModalData } from "../../../common/types/app.types";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import AddPlanModal from "./add-plan-modal";

const SubscriptionsPage = () => {
  const { entityData: addPlanModalData, setEntityData: setAddPlanModalFlagger } = useEntity<ModalData | null>({ entityType: Flaggers.AddPlanModalFlagger });
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };

  const handleAddPlanClick = () => {
    setAddPlanModalFlagger({ show: true }, FlaggersMethods.UpdateFlagger);
  };

  const handleAddPlanModalHide = () => {
    setAddPlanModalFlagger(null, FlaggersMethods.UpdateFlagger);
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className={styles.title}>
              Subscriptions
            </span>
          </div>
          <SearchFilterComponent
            leftSide={(
              <button className="my-button">
                <img src="/images/settings-v2/archived-icon.svg" alt="archived" className="mr-2" />
              </button>
            )}
            searchValue={searchValue}
            searchOnChange={handleSearchOnChange}
            searchOnCross={handleSearchOnCross}
            passedRef={searchInputRef}
            setRef={() => {
              searchInputRef.current?.focus();
            }}
            lastButtonLabel="Add"
            lastButtonOnClick={handleAddPlanClick}
          />
        </div>
        <div className={styles.content}>
          <SubscriptionsTable plansData={plansData} isView={false} />
        </div>
      </div>
      <AddPlanModal isOpen={addPlanModalData?.show ?? false} onClose={handleAddPlanModalHide} />
    </div>
  );
};

export default SubscriptionsPage;
